export const jobsData = [
    {
        title: "Database Engineer",
        description: "Experienced C++ developer who has experience working in high-performance applications. Experience with compilers and/or database internals preferred.",
        requiredSkills: ["C++"],
    },
    {
        title: "Parsing & Translation Engineer",
        description: "Experienced Antlr and Typescript developer who’ll help us parse SQL statements and translate them into various target dialects, both SQL and non-SQL.",
        requiredSkills: ["Antlr", "Typescript", "Transpiler"],
    },
    {
        title: "API / Cloud Engineer",
        description: "A combination DevOps and Developer role who’ll help us build out our APIs and cloud infrastructure. A wide-ranging role that wears many hats, you should have production experience with an application written in NodeJS, Go, or Python.",
        requiredSkills: [
            "API’s",
            "GCP",
            "Serverless",
            "Github Actions",
            ["NodeJS", "Go", "Python"],
        ],
    },
    {
        title: "Data Engineer",
        description: "A creative, multitalented engineer who’ll help us solve the various data-related challenges we have, including in-memory data-stores, batch and streaming ETL pipelines, cross-database joins, always up-to-date materialized views, and much more.",
        requiredSkills: ["Databases", "ETL"],
    },
    {
        title: "Web Developer, Front-end Components",
        description: "Love crafting intuitive, well-designed user experiences? This is a generalized role, and in addition to having expert-level Typescript and CSS/HTML skills (we use Svelte), you should be familiar working with server-side code and databases.",
        requiredSkills: ["Typescript", "Interface", "Charts"],
    },
    {
        title: "Full-Stack Web Architect",
        description: "CTO-like position responsible for the overall application architecture and all performance-related matters outside the database. Should have production experience in at least one statically-typed language, in addition to Javascript/Typescript.",
        requiredSkills: [
            "Architecture",
            "Typescript",
            { skill: "C++", moreInfo: "(or others)" },
        ],
    },
];
export const applyContactEmail = "careers@datadocs.com";
export const openSourceProjects = [
    {
        description: "Add streaming support for simdjson, similar to RapidJSON",
        href: "https://simdjson.org/"
    },
    {
        description: "Add materialized views for DuckDB",
        href: "https://duckdb.org/"
    },
    {
        description: "Add the “MATCH_RECOGNIZE” clause for pattern matching to DuckDB",
        href: "https://duckdb.org/"
    },
];
